// modules/inc.js
const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;

if (ScrollTrigger) {
    try {
        gsap.registerPlugin(ScrollTrigger);
    } catch (e) {}
}

// ————————————————————————————
// Константы/утилиты
// ————————————————————————————
// Константы
const MOBILE_MAX = 1024;
const TABLET_MIN = 680;

// Хелперы
const isMobileNow = () => window.matchMedia(`(max-width:${MOBILE_MAX}px)`).matches;
const isTabletNow = () =>
    window.matchMedia(`(min-width:${TABLET_MIN}px) and (max-width:${MOBILE_MAX}px)`).matches;



const hasNativeSmooth = "scrollBehavior" in document.documentElement.style;
const easeInOut = t => (t < .5 ? 2*t*t : 1 - Math.pow(-2*t + 2, 2)/2);

function smoothScrollX(el, left, duration = 420) {
    const start = el.scrollLeft;
    const d = left - start;
    if (Math.abs(d) < 1) { el.scrollLeft = left; return; }
    if (hasNativeSmooth) { el.scrollTo({ left, behavior: "smooth" }); return; }
    let t0 = null;
    const step = ts => {
        if (t0 == null) t0 = ts;
        const p = Math.min(1, (ts - t0) / duration);
        el.scrollLeft = start + d * easeInOut(p);
        if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
}
function getPeek(section){
    const v = getComputedStyle(section).getPropertyValue('--peek').trim();
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 16;
}
function centerIndexTo(grid, items, idx, padL = 0, dur = 500) {
    idx = Math.max(0, Math.min(items.length - 1, idx));
    const x = items[idx].offsetLeft - grid.offsetLeft - padL;
    smoothScrollX(grid, x, dur);
}
function nearestIndex(grid, items, padL = 0) {
    const center = grid.scrollLeft + padL + grid.clientWidth / 2;
    let best = 0, bestD = 1e12;
    items.forEach((it, i) => {
        const c = it.offsetLeft + it.clientWidth/2;
        const d = Math.abs(c - center);
        if (d < bestD) { bestD = d; best = i; }
    });
    return best;
}
const OPEN_LOGO_ON_TAP = false;
// ————————————————————————————
// 0) Лёгкие GSAP-анимации (если GSAP есть)
// ————————————————————————————
function initGsap(section) {
    try {
        gsap.registerPlugin(ScrollTrigger);
        const header   = section.querySelector(".portfolio__header");
        const title    = section.querySelector(".portfolio__title");
        const subtitle = section.querySelector(".portfolio__subtitle");
        const ellipse  = section.querySelector(".portfolio__ellipse");
        const cards    = gsap.utils.toArray(".portfolio .card");

        if (cards.length) gsap.set(cards, { autoAlpha: 0, y: 24, scale: 0.995, willChange: "transform,opacity" });
        if (ellipse)      gsap.set(ellipse, { autoAlpha: 0, y: 16 });

        gsap.timeline({
            scrollTrigger: { trigger: header || section, start: "top 80%", once: true }
        })
            .to(title,    { opacity: 1, y: 0, duration: .8, ease: "power3.out" })
            .to(subtitle, { opacity: 1, y: 0, duration: .8, ease: "power3.out" }, "-=.4")
            .to(cards,    { autoAlpha: 1, y: 0, scale: 1, duration: .6, ease: "power3.out",
                stagger: { each: .08, from: "start" }, clearProps: "will-change" }, "-=.10")
            .to(ellipse,  { autoAlpha: 1, y: 0, duration: .6, ease: "power2.out" }, "-=.20");

        // мягкий «антизум» бэкграундов карточек
        gsap.set(".portfolio .card__bg", { scale: 1.04 });
        ScrollTrigger.batch(".portfolio .card__bg", {
            start: "top 85%", once: true,
            onEnter: els => gsap.to(els, { scale: 1, duration: .9, ease: "power3.out" })
        });
    } catch (e) { /* тихий фолбэк, если GSAP не подключён */ }
}

// ————————————————————————————
// 1) Мобильный snap-слайдер c drag и пагинацией
// ————————————————————————————
function initMobile(section) {
    const grid   = section.querySelector(".portfolio__grid");
    const slider = section.querySelector(".portfolio__slider");
    const pag    = section.querySelector(".portfolio__pagination");
    if (!grid || !slider) return () => {};

    const cards = [...grid.querySelectorAll(".card")];
    if (!cards.length) return () => {};

    // отключаем hover только на мобилке
    section.classList.add("no-hover-mobile");

    // оси жестов: блокируем только горизонтальные
    let sx=0, sy=0, decided=false, panX=false;
    const DRAG_DEADZONE = 6;
    grid.addEventListener("touchstart", e => {
        const t = e.touches[0]; sx = t.clientX; sy = t.clientY; decided=false; panX=false;
        grid.classList.remove("is-pan-x");
    }, { passive: true });
    grid.addEventListener("touchmove", e => {
        const t = e.touches[0];
        const dx = t.clientX - sx, dy = t.clientY - sy;
        if (!decided) {
            if (Math.abs(dx) < DRAG_DEADZONE && Math.abs(dy) < DRAG_DEADZONE) return;
            panX = Math.abs(dx) > Math.abs(dy) * 1.15;
            decided = true;
            if (panX) grid.classList.add("is-pan-x");
        }
    }, { passive: true });

    // базовая лента
    const ensureLane = () => {
        const cs = getComputedStyle(grid);
        if (cs.display !== "flex") grid.style.display = "flex";
        grid.style.flexWrap = "nowrap";
        grid.style.overflowX = "auto";
        grid.style.overflowY = "visible";
        grid.style.webkitOverflowScrolling = "touch";
        grid.style.scrollSnapType = "x mandatory";
        grid.style.scrollBehavior = "auto";
    };

    const pads = () => {
        const cs = getComputedStyle(section);
        let padL = parseFloat(cs.paddingLeft) || 0;
        let padR = parseFloat(cs.paddingRight) || 0;
        // на мобилке гарантируем минимум 16px слева (как в News)
        if (isMobileNow()) padL = Math.max(padL, 16);
        return { padL, padR };
    };
    const layoutSlides = () => {
        const { padL, padR } = pads();
        const peek = getPeek(section);           // видимая часть следующей карточки
        const trackWidth = section.clientWidth - padL - padR;

        // phone: 1 полная + хвост 2-й; tablet: 2 полные + хвост 3-й
        const visibleCount = isTabletNow() ? 2 : 1;
        const cardW = Math.max(1, (trackWidth - peek) / visibleCount);

        cards.forEach(c => {
            c.style.flex = '0 0 auto';
            c.style.width = cardW + 'px';
            c.style.scrollSnapAlign = 'start';
            c.style.marginLeft = '';
            c.style.marginRight = '';
        });

        section.style.setProperty('--padL', padL + 'px');
        section.style.setProperty('--padR', padR + 'px');

        // слева — внутренний паддинг секции, справа — паддинг + peek
        if (cards[0]) cards[0].style.marginLeft = 'var(--padL)';
        if (cards.length) cards[cards.length - 1].style.marginRight = `calc(var(--padR) + ${peek}px)`;
    };


    // пагинация-буллеты
    const buildBullets = () => {
        if (!pag) return;
        pag.innerHTML = "";
        cards.forEach((_, i) => {
            const dot = document.createElement("span");
            dot.className = "dot" + (i===0 ? " is-active" : "");
            const btn = document.createElement("button");
            btn.type = "button";
            btn.ariaLabel = `Go to slide ${i+1}`;
            dot.appendChild(btn);
            pag.appendChild(dot);
            btn.addEventListener("click", () => {
                const { padL } = pads();
                centerIndexTo(grid, cards, i, padL);
            });
        });
    };
    (function disableCardInteractivity(){
        cards.forEach(card => {
            card.querySelectorAll('a, button, [tabindex]').forEach(el => {
                if (el.tagName.toLowerCase() === 'a' && el.hasAttribute('href')) {
                    el.dataset._href = el.getAttribute('href');
                    el.removeAttribute('href');
                }
                el.setAttribute('tabindex','-1');
                el.setAttribute('aria-disabled','true');
                el.addEventListener('click', e => e.preventDefault());
            });
        });
    })();

// ▼ РАНЬШЕ тут был attachLogoTap — убираем / выключаем:
    if (OPEN_LOGO_ON_TAP) {
        (function attachLogoTap(){
            cards.forEach(card => {
                const logo = card.querySelector('.logoWrap, .logowrap, .card__logoWrap, .logo-wrap');
                if (!logo) return;
                card.addEventListener('click', e => {
                    e.preventDefault(); e.stopPropagation();
                    cards.forEach(c => c.classList.remove('logo-open'));
                    card.classList.add('logo-open');
                }, { passive:false });
            });
            section.addEventListener('click', e => {
                if (!e.target.closest('.card')) cards.forEach(c => c.classList.remove('logo-open'));
            }, { passive:true });
        })();
    }

// на всякий: при монтировании гарантированно всё закрыто
    cards.forEach(c => {
        c.classList.remove('logo-open');
        const ov = c.querySelector('.card__overlay');
        if (ov) ov.classList.remove('is-open');
    });
    const refreshActive = () => {
        if (!pag) return;
        const { padL } = pads();
        const idx = nearestIndex(grid, cards, padL);
        [...pag.children].forEach((d,k) => d.classList.toggle("is-active", k===idx));
    };

    // drag со временным отключением snap
    let dragging=false, startX=0, startSL=0, lastDX=0, startIdx=0;
    const disableSnap = () => {
        grid.dataset.snapWas = getComputedStyle(grid).scrollSnapType || "x mandatory";
        grid.style.scrollSnapType = "none";
        grid.style.webkitOverflowScrolling = "auto";
    };
    const enableSnapLater = () => {
        const enable = () => {
            grid.style.scrollSnapType = grid.dataset.snapWas || "x mandatory";
            grid.style.webkitOverflowScrolling = "touch";
            delete grid.dataset.snapWas;
        };
        if ("onscrollend" in window) {
            const onEnd = () => { enable(); grid.removeEventListener("scrollend", onEnd); };
            grid.addEventListener("scrollend", onEnd, { once: true });
        } else setTimeout(enable, 300);
    };

    grid.addEventListener("touchstart", e => {
        const t = e.touches[0];
        dragging=false; startX=t.clientX; startSL=grid.scrollLeft; lastDX=0;
        const { padL } = pads(); startIdx = nearestIndex(grid, cards, padL);
    }, { passive: true });

    grid.addEventListener("touchmove", e => {
        if (!grid.classList.contains("is-pan-x")) return; // не мешаем вертикали
        if (!dragging) { dragging = true; disableSnap(); }
        e.preventDefault();
        const t = e.touches[0];
        const dx = t.clientX - startX;
        lastDX = dx;
        grid.scrollLeft = startSL - dx;
    }, { passive: false });

    grid.addEventListener("touchend", () => {
        if (!dragging) return;
        dragging=false;
        const w = cards[startIdx].clientWidth;
        const SWIPE_THRESHOLD = 0.25;
        const passed = Math.abs(lastDX) > w * SWIPE_THRESHOLD;
        let targetIdx;
        if (passed) {
            const dir = lastDX > 0 ? -1 : +1;
            targetIdx = Math.max(0, Math.min(cards.length-1, startIdx + dir));
        } else {
            const { padL } = pads();
            targetIdx = nearestIndex(grid, cards, padL);
        }
        const { padL } = pads();
        centerIndexTo(grid, cards, targetIdx, padL);
        enableSnapLater();
    }, { passive: true });

    grid.addEventListener("touchcancel", () => {
        dragging=false;
        const { padL } = pads();
        centerIndexTo(grid, cards, nearestIndex(grid, cards, padL), padL);
        setTimeout(enableSnapLater, 300);
    }, { passive: true });

    grid.addEventListener("scroll", refreshActive, { passive: true });

    // Автоплей (включается, если в секции есть data-autoplay="1")
    const wantAutoplay = section.dataset.autoplay === "1" || section.dataset.autoplay === "true";
    const intervalMs   = parseInt(section.dataset.interval || "5000", 10) || 5000;
    let autoplayId = null, idleTimer = null, userInteracting = false;

    const stopAutoplay = () => { if (autoplayId) { clearInterval(autoplayId); autoplayId = null; } };
    const resumeAutoplayLater = () => {
        if (idleTimer) clearTimeout(idleTimer);
        idleTimer = setTimeout(() => { userInteracting = false; startAutoplay(); }, 1600);
    };
    const startAutoplay = () => {
        if (!wantAutoplay) return;
        const overflow = grid.scrollWidth - grid.clientWidth;
        if (overflow <= 4 || userInteracting) { stopAutoplay(); return; }
        if (autoplayId) return;
        autoplayId = setInterval(() => {
            const { padL } = pads();
            const idx = nearestIndex(grid, cards, padL);
            const next = Math.min(cards.length - 1, idx + 1);
            centerIndexTo(grid, cards, next, padL);
            // jump в начало, когда дошли до конца
            setTimeout(() => {
                const end = grid.scrollWidth - grid.clientWidth;
                if (grid.scrollLeft >= end - 2) {
                    grid.style.scrollSnapType = "none";
                    grid.scrollLeft = 0;
                    setTimeout(() => { grid.style.scrollSnapType = "x mandatory"; }, 16);
                }
            }, 520);
        }, intervalMs);
    };

    function autoLineClamp(){
        const cardsEls = section.querySelectorAll('.card');
        cardsEls.forEach(card => {
            const desc    = card.querySelector('.cardm__desc, .card__desc');
            const overlay = card.querySelector('.cardm__overlay, .card__overlay');
            if (!desc || !overlay) return;

            const csOv = getComputedStyle(overlay);
            let used = (parseFloat(csOv.paddingTop)||0) + (parseFloat(csOv.paddingBottom)||0);

            // что занимает место в overlay
            const blocks = [
                overlay.querySelector('.cardm__year, .card__year'),
                overlay.querySelector('.cardm__year-l, .card__year-l'),
                overlay.querySelector('.btn.btn--pill')
            ];
            blocks.forEach(el => {
                if (!el) return;
                const cs = getComputedStyle(el);
                used += el.getBoundingClientRect().height +
                    (parseFloat(cs.marginTop)||0) + (parseFloat(cs.marginBottom)||0);
            });

            const available = overlay.clientHeight - used;
            const lh = parseFloat(getComputedStyle(desc).lineHeight) || 18;

            // сколько строк реально помещается
            let lines = Math.floor(available / lh);
            lines = Math.max(0, Math.min(7, lines)); // 0..7

            // классы-сигналы для "уровней сжатия"
            const ultraTight = lines < 1;        // даже 1 строка не влезает
            const iconOnly   = lines < 2;        // текст кнопки не влезает

            card.classList.toggle('is-ultra-narrow', ultraTight);
            card.classList.toggle('is-icon-only',   iconOnly);

            // применяем auto clamp
            desc.style.setProperty('--lc', String(Math.max(2, lines))); // если 0..1 → ниже спрячем

            // метка для псевдо-"…"
            const clamped = desc.scrollHeight > desc.clientHeight + 1;
            desc.classList.toggle('is-clamped', clamped);
        });
    }


    ["touchstart","pointerdown","wheel"].forEach(evt => {
        grid.addEventListener(evt, () => { userInteracting = true; stopAutoplay(); resumeAutoplayLater(); }, { passive: true });
    });

    const io = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) startAutoplay(); else stopAutoplay();
    }, { threshold: 0.15 });
    io.observe(section);

    // первый рендер
    ensureLane();
    layoutSlides();
    autoLineClamp()
    buildBullets();

    // зрушуємо до другого елемента, щоб одразу був видно край першого зліва
    const { padL } = pads();
    const START_AT = isTabletNow() ? 0 : Math.min(1, cards.length - 1);

    centerIndexTo(grid, cards, START_AT, padL, 0);

    refreshActive();
    startAutoplay();
    autoLineClamp();

    const ro = new ResizeObserver(() => {
        layoutSlides();
        refreshActive();
        autoLineClamp();   // ← ДОБАВИТЬ
    });



    // возврат «чистильщика»
    return () => {
        stopAutoplay(); io.disconnect(); ro.disconnect();
        grid.removeEventListener("scroll", refreshActive);
        cards[0].style.marginLeft = ""; cards[cards.length-1].style.marginRight = "";
        if (pag) pag.innerHTML = "";
        section.classList.remove("no-hover-mobile");
    };
}

// ————————————————————————————
// Публичный экспорт
// ————————————————————————————
export default function initPortfolio() {
    const section = document.querySelector(".portfolio");
    if (!section) return;

    // лёгкие GSAP-анимации (не трогаем структуру)
    initGsap(section);

    // desktop — без изменений (hover остаётся), mobile — snap-слайдер
    let teardown = null;
    const apply = () => {
        if (teardown) { teardown(); teardown = null; }
        if (isMobileNow()) teardown = initMobile(section);
        else section.classList.remove("no-hover-mobile");
    };
    apply();

    const mq = window.matchMedia(`(max-width:${MOBILE_MAX}px)`);
    (mq.addEventListener ? mq.addEventListener("change", apply) : mq.addListener(apply));
}
